import { useFormContext } from 'form';
import { ConfirmationButton } from 'ui';

import { useDeleteMaterialProduct } from '../../hooks/useDeleteMaterialProduct/useDeleteMaterialProduct';
import { UpdateFormValues } from '../../pages/MaterialProductDetails/MaterialProductDetails';

export const DeleteMaterialProductButton = ({ id }: { id: number }) => {
  const form = useFormContext<UpdateFormValues>();
  const { mutate: deleteMaterialProduct, isPending } = useDeleteMaterialProduct(form);

  return (
    <ConfirmationButton
      variant="secondary"
      title="Are you sure you want to delete it?"
      onConfirm={() => deleteMaterialProduct({ id: id })}
      loading={isPending}
      fullWidth
    >
      Delete
    </ConfirmationButton>
  );
};
